import api from "api";
import { useQuery } from "hooks/query";
import moment from "moment";
import { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { actions } from "redux/reducers";
import { ClipType, TopAuthorType } from "types";
import "./leading-authors.scss";

function LeadingAuthors({ authors, filter }: { authors: TopAuthorType[]; filter: "Followers" | "Clips" }) {
    const params = useParams<any>();
    const query = useQuery();
    const dispatch = useDispatch();

    // const topAuthor = filter === "Followers" ? authors.sort((a, b) => b.FollowerCount - a.FollowerCount).slice(0, 1) : authors.sort((a, b) => b.ClipCount - a.ClipCount).slice(0, 1);
    // const topAuthors = filter === "Followers" ? authors.sort((a, b) => b.FollowerCount - a.FollowerCount).slice(0, 3) : authors.sort((a, b) => b.ClipCount - a.ClipCount).slice(0, 3);
    // console.log(authors);

    const topAuthors = useMemo(() => {
        console.log("XXXX", authors);
        var topAuthors = [];
        if (authors.length > 0) {
            if (filter === "Followers") {
                var top = authors.sort((a, b) => b.FollowerCount - a.FollowerCount)[0];
                var topX = authors.sort((a, b) => b.FollowerCount - a.FollowerCount).filter((x) => x.StreamId === 7)[0];
                var topF = authors.sort((a, b) => b.FollowerCount - a.FollowerCount).filter((x) => x.StreamId === 8)[0];
                var topI = authors.sort((a, b) => b.FollowerCount - a.FollowerCount).filter((x) => x.StreamId === 9)[0];
            } else {
                var top = authors.sort((a, b) => b.ClipCount - a.ClipCount)[0];
                var topX = authors.sort((a, b) => b.ClipCount - a.ClipCount).filter((x) => x.StreamId === 7)[0];
                var topF = authors.sort((a, b) => b.ClipCount - a.ClipCount).filter((x) => x.StreamId === 8)[0];
                var topI = authors.sort((a, b) => b.ClipCount - a.ClipCount).filter((x) => x.StreamId === 9)[0];
            }
            topAuthors = [topX, topF, topI, top];

            return topAuthors;
        }
    }, [authors, filter]);

    const getStreamName = (id: number) => {
        return (
            {
                7: "x-twitter",
                8: "facebook",
                9: "instagram",
                10: "youtube",
                11: "linkedin",
            }[id] || ""
        );
    };

    const onClick = useCallback(
        async (authorId: string, e: any) => {
            e.stopPropagation();
            dispatch(
                actions.clipTray.set({
                    loading: true,
                    clips: [],
                    open: true,
                })
            );
            const projectId = params.projectId;
            const startDate = moment(query.get("datefrom"));
            const endDate = moment(query.get("dateto"));
            const streamIds = query.get("streams")!;
            const clips = await api.clip.getAll(projectId, startDate, endDate, streamIds);
            dispatch(
                actions.clipTray.set({
                    loading: false,
                    clips: clips.filter((x: ClipType) => x.AuthorId === authorId),
                    open: true,
                })
            );
        },
        [dispatch, params, query]
    );

    return (
        <div className="leading-authors-widget">
            {topAuthors &&
                topAuthors.map((x, i) => (
                    <div className="author" key={i} onClick={(e) => onClick(x.AuthorId, e)}>
                        {i !== 3 ? <i className={`fab fa-${getStreamName(x.StreamId)}`} style={{ color: "#FFF" }}></i> : <i className={`spec fa-solid fa-trophy`} style={{ color: "#FFF" }}></i>}

                        <p className="author-name">{x.AuthorName}</p>
                        <p className="author-clip-count">Clips: {x.ClipCount}</p>
                        <p className="author-follower-count">Followers: {x.FollowerCount}</p>
                    </div>
                ))}
        </div>
    );
}

export default LeadingAuthors;
